import { useEffect } from 'react';
import { Outlet, useMatches } from 'react-router';

import type { FC } from 'react';

import { resolveDocumentTitle } from '@/utils/documentTitle';

import { QueryProvider } from 'components/QueryProvider';
import { ToastProvider } from 'components/ui/Toast';
import { ErrorReporter } from 'components/system/ErrorReporter';

import { LiveProvider } from 'containers/LiveProvider';

const RootRoute: FC = () => {
  const matches = useMatches();
  const title = resolveDocumentTitle(matches);

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <QueryProvider>
      <ToastProvider>
        <LiveProvider>
          <ErrorReporter />
          <Outlet />
        </LiveProvider>
      </ToastProvider>
    </QueryProvider>
  );
};

export {
  RootRoute,
};
